import { api } from "@/lib/api";

function cleanPhone(phone = "") {
  const digits = String(phone).replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("91") && digits.length > 10) return digits;
  return digits.length === 10 ? `91${digits}` : digits;
}

function formatDate(value) {
  if (!value) return "";
  const date = new Date(`${value}T00:00:00`);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
}

function doctorLabel(name = "") {
  const clean = String(name || "").trim();
  if (!clean) return "your doctor";
  return clean.toLowerCase().startsWith("dr") ? clean : `Dr. ${clean}`;
}

function appointmentTimeLine(appointment = {}) {
  if (appointment.slot_start_time && appointment.slot_end_time) {
    return `Time: ${appointment.slot_start_time.slice(0, 5)} - ${appointment.slot_end_time.slice(0, 5)}\n`;
  }
  if (appointment.queue_session_label) {
    return `Session: ${appointment.queue_session_label}\n`;
  }
  return "";
}

export function buildAppointmentWhatsAppMessage(appointment, liveQueueUrl) {
  const patient = appointment.patient_name || "Patient";
  const clinic = appointment.clinic_name || appointment.clinic_name_snapshot || "Clinic";
  const token = appointment.token_number != null ? String(appointment.token_number).padStart(2, "0") : "--";

  return [
    `Dear ${patient},`,
    "",
    `Your appointment with ${doctorLabel(appointment.doctor_name)} has been confirmed.`,
    "",
    `Date: ${formatDate(appointment.queue_date)}`,
    appointmentTimeLine(appointment).trim(),
    `Token No: ${token}`,
    `Clinic: ${clinic}`,
    "",
    "Track your live queue here:",
    liveQueueUrl,
    "",
    "If you already have an account, log in with the same mobile number used for booking. If you are new, create your account with this mobile number to view your queue status.",
    "",
    "Regards,",
    "Qenqo",
  ].filter((line) => line !== "").join("\n");
}

export async function shareAppointmentOnWhatsApp(appointment, { sourcePage = "appointments" } = {}) {
  const { data } = await api.post(`/appointments/${appointment.id}/whatsapp-share`, { source_page: sourcePage });
  const shareAppointment = data.appointment || appointment;
  const origin = window.location.origin;
  const liveQueueUrl = `${origin}/live-queue?t=${encodeURIComponent(data.token)}`;
  const message = buildAppointmentWhatsAppMessage(shareAppointment, liveQueueUrl);
  const phone = cleanPhone(shareAppointment.patient_phone || appointment.patient_phone);
  const url = phone
    ? `https://wa.me/${phone}?text=${encodeURIComponent(message)}`
    : `https://wa.me/?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank", "noopener,noreferrer");
  return data;
}
